// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
    getFirestore
} from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDwbC9i5ZxtzNuxRoU6s58ca6S-qcs8PUY",
authDomain: "webapp-radio.firebaseapp.com",
projectId: "webapp-radio",
storageBucket: "webapp-radio.appspot.com",
messagingSenderId: "1020784658402",
appId: "1:1020784658402:web:09a5dc80380aac106fdbbb"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
export { auth };
const db = getFirestore(firebaseApp);
export { db }
const storage = getStorage(firebaseApp)
export { storage }
const database = getDatabase(firebaseApp);
export { database }

export { firebaseApp };